import React, { ReactElement, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Box, Grid } from '@material-ui/core'
import { FormElementWithError } from './FormSongElementWithError'

type FormSongProps = {
  defaultValues?: Record<string, any>
  onSubmit: (data: Record<string, any>) => void
  id?: string
  onKeyPressHandler?: (e: React.SyntheticEvent) => void
  formRef?: React.RefObject<HTMLFormElement>
}
const FormSong: React.FC<FormSongProps> = ({
  defaultValues = {},
  onSubmit,
  id,
  onKeyPressHandler,
  children,
  formRef,
}) => {
  const { register, errors, handleSubmit, reset, setValue, control } = useForm({
    defaultValues,
  })

  useEffect(() => {
    const defaultValuesEffect = (data: Record<string, any>) => {
      if (Object.keys(data).length === 0) return
      Object.keys(defaultValues).forEach((field: string) => {
        setValue(field, defaultValues[field])
      })
    }
    defaultValuesEffect(defaultValues)
  }, [defaultValues, setValue, reset])

  const onSubmitHandler = handleSubmit(onSubmit)

  return (
    <form
      id={id}
      ref={formRef}
      onSubmit={onSubmitHandler}
      className={Object.keys(errors).length ? 'error' : ''}
      data-testid={id}
      onKeyPress={(e) => {
        if (onKeyPressHandler) {
          onKeyPressHandler(e)
        }
      }}
    >
      <Box display='flex' flexDirection='column'>
        <Grid container spacing={2}>
          {React.Children.map(children as ReactElement[], (child) => {
            return child && child.props.name ? (
              <FormElementWithError
                child={child}
                register={register}
                control={control}
                error={errors[child.props.name]}
                rules={child.props.rules}
                required={child.props.required}
                rowsMax={child.props.rowsMax}
                header={child.props.header}
                subheader={child.props.subheader}
                size={child.props.size}
                maxLength={child.props.maxLength}
                titleWithTooltip={child.props.titleWithTooltip}
                tooltipIndex={child.props.tooltipIndex}
                tooltipText={child.props.tooltipText}
                helperMessage={child.props.helperMessage}
              />
            ) : (
              child
            )
          })}
        </Grid>
      </Box>
    </form>
  )
}

export default FormSong
